import httpClient from "../axiosBase/axiosHandler";

export const createConnection = (payload) => {
  return httpClient.post("/marketplaces/connections/", payload);
};

export const updateConnection = ({ id, data }) => {
  return httpClient.patch(`/marketplaces/connections/${id}/`, data);
};

export const getMarketPlaceConnections = () => {
  return httpClient.get("/marketplaces/connections/");
};

export const getStoresMappingList = (queries = "", queryParams = {}) => {
  return httpClient.get(`/marketplaces/stores/mapping-list/${queries}`, {
    params: { ...queryParams },
  });
};

export const getMarketPlaceStores = (
  queries = "",
  queryParams = {},
  providerKey = "",
) => {
  const url =
    providerKey === "squareup"
      ? `/squareup/locations/${queries}`
      : `/marketplaces/stores/${queries}`;
  console.log(url, providerKey);
  return httpClient.get(url, {
    params: { ...queryParams },
  });
};

export const connectChowdeckStore = ({
  data,
  queryParams,
  providerKey = "",
}) => {
  const url =
    providerKey === "squareup"
      ? "/squareup/stores/mapping/"
      : "/marketplaces/stores/mapping/";

  return httpClient.post(url, data, {
    params: { ...queryParams },
  });
};

export const connectChowdeckProducts = ({ data, queryParams = {} }) => {
  return httpClient.post("/marketplaces/products/mapping/", data, {
    params: { ...queryParams },
  });
};

export const updateConnectChowdeckProducts = ({ data, queryParams = {} }) => {
  return httpClient.patch("/marketplaces/products/mapping/update/", data, {
    params: { ...queryParams },
  });
};

export const updateStoreMappingSettings = ({ data, id, queryParams = {} }) => {
  return httpClient.patch(
    `/marketplaces/stores/mapping/${id}/settings/`,
    data,
    { params: { ...queryParams } },
  );
};

export const deleteMarketplaceStoresMapping = ({ id }) => {
  return httpClient.delete(`/marketplaces/stores/mapping/${id}`);
};

export const getChowdeckProducts = (queries = "", queryParams = {}) => {
  return httpClient.get(`/marketplaces/products/${queries}`, {
    params: { ...queryParams },
  });
};

export const getLumiProducts = (queries = "", queryParams = {}) => {
  return httpClient.get(`/marketplaces/products/lumi/${queries}`, {
    params: { ...queryParams },
  });
};

export const getStoreMappingDetails = ({ id, queryParams = {} }) => {
  return httpClient.get(`/marketplaces/stores/mapping-detail/${id}/`, {
    params: { ...queryParams },
  });
};

export const getMappedUnmappedChowdeckProducts = (
  queries = "",
  queryParams = {},
) => {
  return httpClient.get(`/marketplaces/products/mapped-unmapped/${queries}`, {
    params: { ...queryParams },
  });
};

export const authorizeLumiOnSquareup = () => {
  return httpClient.post("/marketplaces/connections/square/oauth/start/", {});
};

export const getSquareAuthStatus = () => {
  return httpClient.get("/marketplaces/connections/square/connection-status/");
};
